import { render, staticRenderFns } from "./LicencesTypesTable.vue?vue&type=template&id=1034f3a8"
import script from "./LicencesTypesTable.vue?vue&type=script&lang=js"
export * from "./LicencesTypesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports